var _path, _path2, _path3, _polygon, _polygon2, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffeeMachine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M33.5,7.9h-1V7.7c0.1-1.2-0.8-2.1-2-2.2c0,0-0.1,0-0.1,0H14.7c-1.2,0-2.1,0.9-2.1,2.1c0,0,0,0.1,0,0.1V8h-1 c-0.9-0.1-1.6,0.6-1.7,1.5c0,0,0,0.1,0,0.1v0.7c0,0.4,0.4,0.8,0.8,0.8c0,0,0,0,0,0h23.7c0.4,0,0.8-0.4,0.8-0.8V9.6 C35.1,8.7,34.4,7.9,33.5,7.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M32.5,11.8H12.6L12,12.1c-0.1,0.1-0.2,0.3-0.1,0.5l2.4,26.2c0,0.4,0.3,0.7,0.7,0.7h15.1 c0.4,0,0.7-0.3,0.7-0.7l0,0l2.5-26.2c0-0.2-0.1-0.4-0.2-0.5L32.5,11.8z M29.4,38.1H15.7L15,30.9h15.1L29.4,38.1z M30.1,29.4H14.8 l-0.7-7.5h16.8L30.1,29.4z M31,20.5H14l-0.7-7.2h18.5L31,20.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M14.8,29.4h15.4l0.7-7.5H14.1L14.8,29.4z M22.5,23.2c1.7,0,3.1,0.7,3.5,1.8s-0.1,0.2-0.1,0.1l-1.6-0.2 c-0.7,0-1.3,0.1-1.9,0.4c-1,0.4-2.2,0.5-3.2,0.1c-0.1,0-0.2-0.1-0.1-0.3C19.1,24.9,20.8,23.2,22.5,23.2z M19.2,26.2l1.5,0.2 c0.7,0,1.4-0.1,2-0.4c1-0.4,2.1-0.5,3.1-0.1c0.1,0,0.2,0.2,0.2,0.3s-1.8,2-3.5,2c-1.4,0.1-2.8-0.6-3.4-1.9 C19,26.2,19,26.1,19.2,26.2z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "15.7,38.1 29.4,38.1 30.1,30.9 15,30.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "14,20.5 31.1,20.5 31.8,13.3 13.2,13.3 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M22.5,28.2c1.7,0,3.2-0.9,3.5-2c0.3-1.1-0.1-0.3-0.2-0.3c-1-0.4-2.1-0.3-3.1,0.1c-0.6,0.3-1.3,0.4-2,0.4 l-1.5-0.2c-0.1-0.1-0.1,0-0.1,0.1C19.7,27.6,21,28.3,22.5,28.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M19.2,25.4c1,0.4,2.2,0.3,3.2-0.1c0.6-0.3,1.2-0.4,1.9-0.4l1.6,0.2c0,0.1,0.1,0,0.1-0.1s-1.8-1.8-3.5-1.8 s-3.1,0.8-3.4,1.9S19,25.4,19.2,25.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeMachine);
export default __webpack_public_path__ + "static/media/coffee_machine.d87ff9cc3628736fe4166434f073b2df.svg";
export { ForwardRef as ReactComponent };